import filtype from './filtype'

const enhetsrapporter = {
    personbilulykker: {
        aktivertITrine: true,
        tekniskNavn: 'personbilulykker',
        visningsnavn: 'Personbilulykker',
        filtyper: [filtype.pdf]
    },
    tungbilulykker: {
        aktivertITrine: true,
        tekniskNavn: 'tungbilulykker',
        visningsnavn: 'Tungbilulykker',
        filtyper: [filtype.pdf]
    },
    bussulykker: {
        aktivertITrine: false,
        tekniskNavn: 'bussulykker',
        visningsnavn: 'Bussulykker',
        filtyper: [filtype.pdf]
    },
    sykkelulykker: {
        aktivertITrine: false,
        tekniskNavn: 'sykkelulykker',
        visningsnavn: 'Sykkelulykker',
        filtyper: [filtype.pdf]
    },
    fotgjengerulykker: {
        aktivertITrine: true,
        tekniskNavn: 'fotgjengerulykker',
        visningsnavn: 'Fotgjengerulykker',
        filtyper: [filtype.pdf]
    },
    mc_og_mopedulykker: {
        aktivertITrine: true,
        tekniskNavn: 'mc_og_mopedulykker',
        visningsnavn: 'MC og mopedulykker',
        filtyper: [filtype.pdf]
    }
}

export default enhetsrapporter
